import React from "react";

const SortIcon = ({ size = 16, className = "text-dark-gray" }) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 16"
      >
        <path
          fill="currentColor"
          d="m4.668 10 3.333 3.333L11.335 10zM4.668 6l3.333-3.333L11.335 6z"
        />
      </svg>
    </span>
  );
};

export default SortIcon;
